import * as SelectPrimitive from '@radix-ui/react-select'
import { ChevronDown as ChevronDownIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { styled } from '@stitches/react'

const SelectRoot = SelectPrimitive.Root
const SelectTrigger = styled(SelectPrimitive.SelectTrigger,
  {
    all: 'unset',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 4,
    padding: '4px 8px',
    minWidth: 80,
    fontSize: 12,
    lineHeight: 1,
    gap: 5,
    // backgroundColor: '#0A0A0A',
    backgroundColor: 'white',
    color: '#2D3748',
    //border: '1px solid #313034',
    border: '1px solid #E2E8F0',
    '&:hover': {
    //backgroundColor: '#313034',
      backgroundColor: '#EDF2F7',
      cursor: 'pointer',
    },
    '&:focus': { border: '1px solid #EBF4FF' },
    '&[data-placeholder]': { color: '#2D3748' },
  })
const SelectValue = SelectPrimitive.Value
const SelectIcon = styled(SelectPrimitive.Icon,
  { color: '#A0AEC0' })
const SelectContent = styled(SelectPrimitive.Content,
  {
    overflow: 'hidden',
    background: '#EDF2F7',
    borderRadius: 4,
    border: '1px solid #E2E8F0',
    padding: 4,
  })
const Content = ({
  children,
  ...props
}: { children: ReactNode; props?: any }) => (
  <SelectPrimitive.Portal>
    <SelectContent {...props}>{children}</SelectContent>
  </SelectPrimitive.Portal>
)
const SelectViewport = SelectPrimitive.Viewport
const SelectItemComponent = styled(SelectPrimitive.Item,
  {
    all: 'unset',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 4,
    padding: '8px 4px',
    minWidth: 80,
    fontSize: 12,
    lineHeight: 1,
    gap: 5,
    userSelect: 'none',
    backgroundColor: '#EDF2F7',
    color: '#2D3748',
    '&:hover': {
      backgroundColor: '#E2E8F0',
      cursor: 'pointer',
    },
  })
const SelectItemText = SelectPrimitive.ItemText
const SelectGroupComponent = SelectPrimitive.Group
const SelectLabel = styled(SelectPrimitive.Label,
  {
    padding: '0 4px',
    fontSize: 12,
    lineHeight: '25px',
    //color: 'rgba(255, 255, 255, 0.5)',
    color: '#718096',
  })

export interface SelectItem {
  value: string
  text: string
  icon?: ReactNode
}

export interface SelectGroup {
  label: string
  items: SelectItem[]
}

export interface Props {
  groups: SelectGroup[]
  defaultItem: SelectItem
  selectedValue: string
  onValueChange: (value: string) => void
}

function Select({
  groups,
  selectedValue,
  defaultItem,
  onValueChange,
}: Props) {
  return (
    <SelectRoot value={selectedValue} onValueChange={onValueChange}>
      <SelectTrigger >
        <SelectValue placeholder={defaultItem.value} />
        <SelectIcon>
          <ChevronDownIcon
            color="currentColor"
            size={12}
          />
        </SelectIcon>
      </SelectTrigger>

      <Content>
        <SelectViewport>
          {groups.map(g => (
            <SelectGroupComponent key={g.label}>
              <SelectLabel>{g.label}</SelectLabel>
              {g.items.map(i => (
                <SelectItemComponent
                  key={i.value}
                  value={i.value}
                >
                  {i.icon}
                  <SelectItemText>{i.text}</SelectItemText>
                </SelectItemComponent>
              ))}
            </SelectGroupComponent>
          ))}
        </SelectViewport>
      </Content>
    </SelectRoot>
  )
}

export default Select
